<template>
    <div class="team_store create_team_store">
        <section class="breadcrumb-section pb-0">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a href="#">Home</a></li>
                        <!-- <li class="breadcrumb-item"><a href="#">Cart</a></li> -->
                        <li class="breadcrumb-item active" aria-current="page">
                            Team Store
                        </li>
                    </ol>
                </nav>
            </div>
        </section>
        <section class="store_banner mt_20">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 text-left">
                        <h1 class="banner_heading2 text-white">
                            Create Team Store
                        </h1>
                    </div>
                </div>
            </div>
        </section>

        <section class="select_template pt_54">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-lg-12 col-xl-4">
                        <a
                            href="/team/custom-store"
                            class="create_new_templeate mt_80"
                        >
                            <img
                                src="/maincss/images/add_more_brand.svg"
                                alt=" "
                            />
                            <p
                                class="font_size_24 text_primary_blue mt_10 mb-0"
                            >
                                Create New
                            </p>
                        </a>
                    </div>
                    <div class="col-md-12 col-lg-12 col-xl-8">
                        <div class="row">
                            <div class="col-md-12">
                                <h1 class="heading1 m-0">
                                    Choose From Template
                                </h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-lg-4">
                                <div class="templates">
                                    <img
                                        src="/maincss/images/template_1.png"
                                        alt=" "
                                    />
                                    <p class="font_size_18">
                                        Starter Pack Football
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="templates">
                                    <img
                                        src="/maincss/images/template_2.png"
                                        alt=" "
                                    />
                                    <p class="font_size_18">
                                        Starter Pack Basketball
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="templates">
                                    <img
                                        src="/maincss/images/template_3.png"
                                        alt=" "
                                    />
                                    <p class="font_size_18">
                                        Starter Pack Soccer
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="templates">
                                    <img
                                        src="/maincss/images/template_4.png"
                                        alt=" "
                                    />
                                    <p class="font_size_18">
                                        Starter Pack Swimming
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <div class="templates">
                                    <img
                                        src="/maincss/images/template_5.png"
                                        alt=" "
                                    />
                                    <p class="font_size_18">
                                        Starter Pack Cricket
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "CreateTeamStore",
    components: {},
    mounted() {
        document.body.classList.remove("bg_primary_light_white");
        document.body.classList.add("footer_spacing_mange");
    },
    computed: {
        // ...mapGetters(["isAuthenticated", "tags"]),
        // tag() {
        //   return this.$route.params.tag;
        // }
    }
};
</script>
